import common from './common'

const sideprojects = {
  ...common.button,
  color: `text`,
  bg: `alphaLighter`,
  borderColor: `text`,
  borderWidth: `1px`,
  borderStyle: `solid`,
  ':hover': {
    color: `omegaLighter`,
    bg: `omegaDark`,
    borderColor: `omegaDark`
  },
  gap: 1,
  svg: {
    size: 20,
    minWidth: 'fit-content'
  },
}

export default sideprojects